<template>
  <SelectApi endpoint="articles" :itemTitle="opt => `${opt.name} (${opt.part_number})`" />
</template>

<script>
export default {
  name: 'SelectArticle'
};
</script>
